import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
export function AnimatedCounter({
  value,
  className = ''
}: {
  value: number;
  className?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-40px'
  });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(reduce ? value : 0);
  useEffect(() => {
    if (!inView) return;
    if (reduce) {
      setDisplay(value);
      return;
    }
    const controls = animate(0, value, {
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setDisplay(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, value, reduce]);
  return <span ref={ref} className={className} data-id="element-486" data-mp="1nyr3u39f9xmz">
      {display}
    </span>;
}